import React from 'react';

interface SchoolDuplicatesSkeletonProps {
  groups?: number;
}

const DEFAULT_GROUPS = 3;
const ROWS_PER_GROUP = 2;

const Bone = ({ className }: { className: string }) => <div className={`skeleton ${className}`} />;

/** Mirrors the duplicates page: a card per group, two candidate rows each with a radio, name, anchors and an action. */
const SchoolDuplicatesSkeleton: React.FC<SchoolDuplicatesSkeletonProps> = ({ groups = DEFAULT_GROUPS }) => (
  <div className="space-y-4">
    {Array.from({ length: groups }).map((_, g) => (
      <div key={g} className="card">
        <div className="card-header space-y-1.5">
          <Bone className="h-4 w-48" />
          <Bone className="h-3 w-64" />
        </div>
        <div className="card-body space-y-2">
          {Array.from({ length: ROWS_PER_GROUP }).map((_, r) => (
            <div key={r} className="flex items-start gap-3 rounded-lg border border-border px-4 py-3">
              <Bone className="h-4 w-4 rounded-full mt-0.5" />
              <div className="flex-1 space-y-1.5">
                <div className="flex items-center gap-2">
                  <Bone className="h-4 w-56" />
                  <Bone className="h-5 w-20 rounded-full" />
                </div>
                <Bone className="h-3 w-40" />
                <div className="flex gap-1.5">
                  <Bone className="h-4 w-24 rounded" />
                  <Bone className="h-4 w-16 rounded" />
                </div>
              </div>
              <Bone className="h-8 w-20 rounded-md" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default SchoolDuplicatesSkeleton;
